var map = {
	"./Flag of Afghanistan.gif": 82,
	"./Flag of Akrotiri.gif": 83,
	"./Flag of Albania.gif": 84,
	"./Flag of Algeria.gif": 85,
	"./Flag of American Samoa.gif": 86,
	"./Flag of Andorra.gif": 87,
	"./Flag of Angola.gif": 88,
	"./Flag of Anguilla.gif": 89,
	"./Flag of Antigua and Barbuda.gif": 90,
	"./Flag of Argentina.gif": 91,
	"./Flag of Armenia.gif": 92,
	"./Flag of Aruba.gif": 93,
	"./Flag of Ashmore and Cartier Islands.gif": 94,
	"./Flag of Australia.gif": 95,
	"./Flag of Austria.gif": 96,
	"./Flag of Azerbaijan.gif": 97,
	"./Flag of Bahrain.gif": 98,
	"./Flag of Bangladesh.gif": 99,
	"./Flag of Barbados.gif": 100,
	"./Flag of Belarus.gif": 101,
	"./Flag of Belgium.gif": 102,
	"./Flag of Belize.gif": 103,
	"./Flag of Benin.gif": 104,
	"./Flag of Bermuda.gif": 105,
	"./Flag of Bhutan.gif": 106,
	"./Flag of Bolivia.gif": 107,
	"./Flag of Bosnia and Herzegovina.gif": 108,
	"./Flag of Botswana.gif": 109,
	"./Flag of Bouvet Island.gif": 110,
	"./Flag of Brazil.gif": 111,
	"./Flag of British Indian Ocean Territory.gif": 112,
	"./Flag of British Virgin Islands.gif": 113,
	"./Flag of Brunei.gif": 114,
	"./Flag of Bulgaria.gif": 115,
	"./Flag of Burkina Faso.gif": 116,
	"./Flag of Burma.gif": 117,
	"./Flag of Burundi.gif": 118,
	"./Flag of Cambodia.gif": 119,
	"./Flag of Cameroon.gif": 120,
	"./Flag of Canada.gif": 121,
	"./Flag of Cape Verde.gif": 122,
	"./Flag of Cayman Islands.gif": 123,
	"./Flag of Central African Republic.gif": 124,
	"./Flag of Chad.gif": 125,
	"./Flag of Chile.gif": 126,
	"./Flag of China.gif": 127,
	"./Flag of Christmas Island.gif": 128,
	"./Flag of Clipperton Island.gif": 129,
	"./Flag of Cocos (Keeling) Islands.gif": 130,
	"./Flag of Colombia.gif": 131,
	"./Flag of Comoros.gif": 132,
	"./Flag of Cook Islands.gif": 133,
	"./Flag of Coral Sea Islands.gif": 134,
	"./Flag of Costa Rica.gif": 135,
	"./Flag of Cote d'Ivoire.gif": 136,
	"./Flag of Croatia.gif": 137,
	"./Flag of Cuba.gif": 138,
	"./Flag of Cyprus.gif": 139,
	"./Flag of Czech Republic.gif": 140,
	"./Flag of Democratic Republic of the Congo.gif": 141,
	"./Flag of Denmark.gif": 142,
	"./Flag of Dhekelia.gif": 143,
	"./Flag of Djibouti.gif": 144,
	"./Flag of Dominica.gif": 145,
	"./Flag of Dominican Republic.gif": 146,
	"./Flag of East Timor.gif": 147,
	"./Flag of Ecuador.gif": 148,
	"./Flag of Egypt.gif": 149,
	"./Flag of El Salvador.gif": 150,
	"./Flag of Equatorial Guinea.gif": 151,
	"./Flag of Eritrea.gif": 152,
	"./Flag of Estonia.gif": 153,
	"./Flag of Ethiopia.gif": 154,
	"./Flag of European Union.gif": 155,
	"./Flag of Falkland Islands.gif": 156,
	"./Flag of Faroe Islands.gif": 157,
	"./Flag of Fiji.gif": 158,
	"./Flag of Finland.gif": 159,
	"./Flag of France.gif": 160,
	"./Flag of French Polynesia.gif": 161,
	"./Flag of French Southern and Antarctic Lands.gif": 162,
	"./Flag of Gabon.gif": 163,
	"./Flag of Gambia, The.gif": 164,
	"./Flag of Georgia.gif": 165,
	"./Flag of Germany.gif": 166,
	"./Flag of Ghana.gif": 167,
	"./Flag of Gibraltar.gif": 168,
	"./Flag of Greece.gif": 169,
	"./Flag of Greenland.gif": 170,
	"./Flag of Grenada.gif": 171,
	"./Flag of Guam.gif": 172,
	"./Flag of Guatemala.gif": 173,
	"./Flag of Guernsey.gif": 174,
	"./Flag of Guinea Bissau.gif": 175,
	"./Flag of Guinea.gif": 176,
	"./Flag of Guyana.gif": 177,
	"./Flag of Haiti.gif": 178,
	"./Flag of Heard Island and McDonald Islands.gif": 179,
	"./Flag of Holy See (Vatican City).gif": 180,
	"./Flag of Honduras.gif": 181,
	"./Flag of Hong Kong.gif": 182,
	"./Flag of Hungary.gif": 183,
	"./Flag of Iceland.gif": 184,
	"./Flag of India.gif": 185,
	"./Flag of Indonesia.gif": 186,
	"./Flag of Iran.gif": 187,
	"./Flag of Iraq.gif": 188,
	"./Flag of Ireland.gif": 189,
	"./Flag of Isle of Man.gif": 190,
	"./Flag of Israel.gif": 191,
	"./Flag of Italy.gif": 192,
	"./Flag of Jamaica.gif": 193,
	"./Flag of Jan Mayen.gif": 194,
	"./Flag of Japan.gif": 195,
	"./Flag of Jersey.gif": 196,
	"./Flag of Jordan.gif": 197,
	"./Flag of Kazakhstan.gif": 198,
	"./Flag of Kenya.gif": 199,
	"./Flag of Kiribati.gif": 200,
	"./Flag of Kosovo.gif": 201,
	"./Flag of Kuwait.gif": 202,
	"./Flag of Kyrgyzstan.gif": 203,
	"./Flag of Laos.gif": 204,
	"./Flag of Latvia.gif": 205,
	"./Flag of Lebanon.gif": 206,
	"./Flag of Lesotho.gif": 207,
	"./Flag of Liberia.gif": 208,
	"./Flag of Libya.gif": 209,
	"./Flag of Liechtenstein.gif": 210,
	"./Flag of Lithuania.gif": 211,
	"./Flag of Luxembourg.gif": 212,
	"./Flag of Macau.gif": 213,
	"./Flag of Macedonia.gif": 214,
	"./Flag of Madagascar.gif": 215,
	"./Flag of Malawi.gif": 216,
	"./Flag of Malaysia.gif": 217,
	"./Flag of Maldives.gif": 218,
	"./Flag of Mali.gif": 219,
	"./Flag of Malta.gif": 220,
	"./Flag of Marshall Islands.gif": 221,
	"./Flag of Mauritania.gif": 222,
	"./Flag of Mauritius.gif": 223,
	"./Flag of Mayotte.gif": 224,
	"./Flag of Mexico.gif": 225,
	"./Flag of Micronesia, Federated States of.gif": 226,
	"./Flag of Moldova.gif": 227,
	"./Flag of Monaco.gif": 228,
	"./Flag of Mongolia.gif": 229,
	"./Flag of Montenegro.gif": 230,
	"./Flag of Montserrat.gif": 231,
	"./Flag of Morocco.gif": 232,
	"./Flag of Mozambique.gif": 233,
	"./Flag of Namibia.gif": 234,
	"./Flag of Nauru.gif": 235,
	"./Flag of Navassa Island.gif": 236,
	"./Flag of Nepal.gif": 237,
	"./Flag of Netherlands Antilles.gif": 238,
	"./Flag of Netherlands.gif": 239,
	"./Flag of New Caledonia.gif": 240,
	"./Flag of New Zealand.gif": 241,
	"./Flag of Nicaragua.gif": 242,
	"./Flag of Niger.gif": 243,
	"./Flag of Nigeria.gif": 244,
	"./Flag of Niue.gif": 245,
	"./Flag of Norfolk Island.gif": 246,
	"./Flag of North Korea.gif": 247,
	"./Flag of Northern Mariana Islands.gif": 248,
	"./Flag of Norway.gif": 249,
	"./Flag of Oman.gif": 250,
	"./Flag of Pakistan.gif": 251,
	"./Flag of Palau.gif": 252,
	"./Flag of Panama.gif": 253,
	"./Flag of Papua New Guinea.gif": 254,
	"./Flag of Paraguay.gif": 255,
	"./Flag of Peru.gif": 256,
	"./Flag of Philippines.gif": 257,
	"./Flag of Pitcairn Islands.gif": 258,
	"./Flag of Poland.gif": 259,
	"./Flag of Portugal.gif": 260,
	"./Flag of Puerto Rico.gif": 261,
	"./Flag of Qatar.gif": 262,
	"./Flag of Republic of Serbia.gif": 263,
	"./Flag of Republic of the Congo.gif": 264,
	"./Flag of Romania.gif": 265,
	"./Flag of Russia.gif": 266,
	"./Flag of Rwanda.gif": 267,
	"./Flag of Saint Barthelemy.gif": 268,
	"./Flag of Saint Helena, Ascension, and Tristan da Cunha.gif": 269,
	"./Flag of Saint Kitts and Nevis.gif": 270,
	"./Flag of Saint Lucia.gif": 271,
	"./Flag of Saint Martin.gif": 272,
	"./Flag of Saint Pierre and Miquelon.gif": 273,
	"./Flag of Saint Vincent and the Grenadines.gif": 274,
	"./Flag of Samoa.gif": 275,
	"./Flag of San Marino.gif": 276,
	"./Flag of Sao Tome and Principe.gif": 277,
	"./Flag of Saudi Arabia.gif": 278,
	"./Flag of Senegal.gif": 279,
	"./Flag of Seychelles.gif": 280,
	"./Flag of Sierra Leone.gif": 281,
	"./Flag of Singapore.gif": 282,
	"./Flag of Slovakia.gif": 283,
	"./Flag of Slovenia.gif": 284,
	"./Flag of Solomon Islands.gif": 285,
	"./Flag of Somalia.gif": 286,
	"./Flag of South Africa.gif": 287,
	"./Flag of South Georgia and South Sandwich Islands.gif": 288,
	"./Flag of South Korea.gif": 289,
	"./Flag of Spain.gif": 290,
	"./Flag of Sri Lanka.gif": 291,
	"./Flag of Sudan.gif": 292,
	"./Flag of Suriname.gif": 293,
	"./Flag of Svalbard.gif": 294,
	"./Flag of Swaziland.gif": 295,
	"./Flag of Sweden.gif": 296,
	"./Flag of Switzerland.gif": 297,
	"./Flag of Syria.gif": 298,
	"./Flag of Taiwan.gif": 299,
	"./Flag of Tajikistan.gif": 300,
	"./Flag of Thailand.gif": 301,
	"./Flag of The Bahamas.gif": 302,
	"./Flag of Togo.gif": 303,
	"./Flag of Tokelau.gif": 304,
	"./Flag of Tonga.gif": 305,
	"./Flag of Trinidad and Tobago.gif": 306,
	"./Flag of Tunisia.gif": 307,
	"./Flag of Turkey.gif": 308,
	"./Flag of Turkmenistan.gif": 309,
	"./Flag of Turks and Caicos Islands.gif": 310,
	"./Flag of Tuvalu.gif": 311,
	"./Flag of Uganda.gif": 312,
	"./Flag of Ukraine.gif": 313,
	"./Flag of United Arab Emirates.gif": 314,
	"./Flag of United Kingdom.gif": 315,
	"./Flag of United Republic of Tanzania.gif": 316,
	"./Flag of United States Pacific Island Wildlife Refuges.gif": 317,
	"./Flag of United States of America.gif": 318,
	"./Flag of Uruguay.gif": 319,
	"./Flag of Uzbekistan.gif": 320,
	"./Flag of Vanuatu.gif": 321,
	"./Flag of Venezuela.gif": 322,
	"./Flag of Vietnam.gif": 323,
	"./Flag of Virgin Islands.gif": 324,
	"./Flag of Wake Island.gif": 325,
	"./Flag of Wallis and Futuna.gif": 326,
	"./Flag of Yemen.gif": 327,
	"./Flag of Zambia.gif": 328,
	"./Flag of Zimbabwe.gif": 329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;